var _rect, _path, _path2, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "white",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3575 21.4285C20.3575 16.1029 24.6748 11.7856 30.0004 11.7856C35.326 11.7856 39.6432 16.1029 39.6432 21.4285C39.6432 26.7541 35.326 31.0714 30.0004 31.0714C24.6748 31.0714 20.3575 26.7541 20.3575 21.4285Z",
    fill: "#F8F8F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3245 51.6542C12.4902 42.0333 20.3403 34.2856 30.0004 34.2856C39.6606 34.2856 47.5109 42.0337 47.6763 51.6549C47.6872 52.293 47.3196 52.8771 46.7396 53.1432C41.6419 55.4823 35.9715 56.7856 30.001 56.7856C24.0301 56.7856 18.3591 55.4821 13.261 53.1426C12.681 52.8764 12.3135 52.2923 12.3245 51.6542Z",
    fill: "#F8F8F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48.2142,
    y: 48.2142,
    width: 10.7143,
    height: 10.7143,
    rx: 5.35714,
    fill: "#0FB700"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 48.2142,
    y: 48.2142,
    width: 10.7143,
    height: 10.7143,
    rx: 5.35714,
    stroke: "#FDFDFD",
    strokeWidth: 2.14286
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.c75492e4af2e02f50777b55053a86f20.svg";
export { ForwardRef as ReactComponent };